<template>
  <div>
    <h4>PayPal</h4>
    <div class="mt-2 mb-4">
      Um e-mail com os dados do pedido será enviado para <strong>{{ basket.email }}</strong>
    </div>

    <WhatsAppPhoneInput :basket="basket" />

    <PayPal
      class="my-6"
      v-if="componentKey > 0"
      :key="componentKey"
      :amount="payPalExpress.amount"
      :currency="basket.currency_code"
      :locale="payPalExpress.locale"
      :items="payPalExpress.items"
      :env="payPalExpress.mode"
      :button-style="payPalExpress.style"
      :client="payPalExpress.credentials"
      :experience="payPalExpress.experience"
      v-on:payment-completed="payPalExpressPaymentCompleted"
    ></PayPal>
  </div>
</template>

<script>
import WhatsAppPhoneInput from '../WhatsAppPhoneInput.vue';
import PayPal from 'vue-paypal-checkout';

var watchBasketTotal;
export default {
  components: {
    WhatsAppPhoneInput,
    PayPal
  },
  props: {
    checkoutWizard: {
      type: Object,
      required: true
    },
    paymentMethod: {
      type: String,
      required: true
    },
    basket: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      componentKey: 0,
      payPalExpress: {
        mode: process.env.VUE_APP_PAYPAL_MODE,
        credentials: {
          sandbox: process.env.VUE_APP_PAYPAL_SANDBOX_CLIENT_ID,
          production: process.env.VUE_APP_PAYPAL_PRODUCTION_CLIENT_ID
        },
        amount: '',
        locale: 'pt_BR',
        items: [],
        style: {
          layout: 'horizontal',
          label: '',
          installmentperiod: 0,
          size: 'responsive',
          shape: 'pill'
        },
        experience: {
          flow_config: {
            landing_page_type: 'billing'
          },
          input_fields: {
            no_shipping: 1
          }
        }
      }
    };
  },
  mounted() {
    this.payPalExpress.locale = this.basket.locale.replace('-', '_');
  },
  watch: {
    'basket.total'() {
      watchBasketTotal = setTimeout(() => {
        if (this.basket.total > 0) {
          clearTimeout(watchBasketTotal);
          this.payPalExpress.amount = this.basket.total.toString();
          this.componentKey += 1;
        }
      }, 500);
    }
  },
  methods: {
    payPalExpressPaymentCompleted: function (payPalResponse) {
      this.basket.processing = true;

      this.$api
        .post('/api/v1/checkout/order/capture', {
          payment_method: this.paymentMethod,
          basket: this.basket,
          data: payPalResponse
        })
        .then(response => {
          if (response.data && parseInt(response.data.orderId) > 0) {
            window.location.href =
              '/checkout/complete?orderId=' + response.data.orderId + '&orderNumber=' + response.data.orderNumber;
          } else {
            this.basket.processing = false;
            this.$vs.notify({
              time: 10000,
              text: 'Não foi possível processar seu pedido. Atualize a página e tente novamente.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            });
          }
        })
        .catch(error => {
          this.basket.processing = false;
          this.$vs.notify({
            time: 10000,
            text: error.response.data.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        });
    }
  }
};
</script>
